/**
 * @generated SignedSource<<2b222ec7f5f103eee901a3be70bd3cab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row345BadPattern$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Row405BadPattern" | "Row73BadPattern">;
  readonly " $fragmentType": "Row345BadPattern";
};
export type Row345BadPattern$key = {
  readonly " $data"?: Row345BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row345BadPattern">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isDensityFull",
    "variableName": "isDensityFull"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "Row345BadPattern",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row73BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row405BadPattern"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "c9168010679e21bed90ba10a747b1be6";

export default node;
